import * as Yup from 'yup';

export default Yup.object().shape({
  displayName: Yup.string().required('Please input your username'),
  firstName: Yup.string().required('Please input your first name'),
  lastName: Yup.string().required('Please input your last name'),
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
  role: Yup.string()
    .nullable()
    .required(),
  password: Yup.string().required('Required'),
  confirm: Yup.string().oneOf(
    [Yup.ref('password'), null],
    'passwords should match'
  ),
});
